/**
 * ActivityLogTab - Campaign activity log display
 */
import { Cake, UserMinus, Gift, Phone, Mail } from 'lucide-react';
import { formatDate } from './automatedUtils';

export default function ActivityLogTab({ campaignLog }) {
  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden">
      <div className="p-4 border-b border-border">
        <h3 className="font-medium">Campaign Activity Log</h3>
      </div>
      <div className="divide-y divide-border max-h-96 overflow-y-auto">
        {campaignLog.length === 0 ? (
          <p className="text-center text-muted-foreground py-8">No campaign activity yet</p>
        ) : (
          campaignLog.map((log, i) => (
            <div key={i} className="p-3 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  log.campaign_type === 'birthday' ? 'bg-pink-500/10 text-pink-500' :
                  log.campaign_type === 'reengagement' ? 'bg-orange-500/10 text-orange-500' :
                  'bg-blue-500/10 text-blue-500'
                }`}>
                  {log.campaign_type === 'birthday' ? <Cake className="w-4 h-4" /> :
                   log.campaign_type === 'reengagement' ? <UserMinus className="w-4 h-4" /> :
                   <Gift className="w-4 h-4" />}
                </div>
                <div>
                  <p className="font-medium text-sm">{log.contact_name || 'Unknown'}</p>
                  <p className="text-xs text-muted-foreground">
                    {log.campaign_type} • Code: {log.code} • {log.discount_percent}% off
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-xs text-muted-foreground">{formatDate(log.sent_at)}</p>
                <div className="flex items-center gap-1 mt-1">
                  {log.notifications?.sms?.success && <Phone className="w-3 h-3 text-green-500" />}
                  {log.notifications?.email?.success && <Mail className="w-3 h-3 text-green-500" />}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
